
<ion-content #content scroll-x="true" [class.onDrag]="onDrag" class="show-scrollbar" [scrollEvents]="true" (ionScroll)="handleScroll($event)" *ngIf="genralSrv.serverVersionGreaterThan('1.10.0') && !resizeManager.isPortrait">
  <section id="no-boards" *ngIf="boardTemplateSrv.templates.length == 0 && !boardTemplateSrv.isLoading && genralSrv.serverVersionGreaterThan('1.10.0')">
    <ion-icon name="fa-table"></ion-icon>
    <h1>Willkommen bei Ihren Boards!</h1>
    <p>In diesem Bereich können Sie Ihre Tickets in einer Board-Ansicht anzeigen lassen. <br>Ihre Boards können Sie beliebig filtern, verwalten und freigeben.</p> 
    <div id="chips">
      <ion-chip mode="ios" (click)="createDefaultTemplate()">Standard Board erstellen lassen</ion-chip>
      <ion-chip mode="ios" (click)="createTemplate()">Eigenes Board erstellen</ion-chip>
    </div>
  </section>

  <section #settingsWrapper id="settings" *ngIf=" boardTemplateSrv.templates.length > 0 ">
    <div id="settings-wrapper">
      <div class="tags">
        <div style="position: relative;"  *ngFor="let template of boardTemplateSrv.templates" >
          <div class="public-badge" *ngIf="template.public"></div>
          <ion-chip class="button-chip" mode="ios" (click)="selectTemplate(template)" [class.activeTemplate]="template == boardTemplateSrv.activeBoardTemplateBase">
            <ion-icon [name]="template.icon"></ion-icon>
            <ion-label>{{template.name}}</ion-label>
          </ion-chip>
        </div>
      </div>

      <div id="setting-actions">
        <input #searchInput type="text" placeholder="Bezeichnung, Adresse..." [(ngModel)]="searchText" (blur)="searchBlur()" [class.inputOpen]="searchOpen" (keyup.escape)="searchText = ''" (keydown)="searchKeyUp()">
        <ion-chip mode="ios" id="saveChip" *ngIf="anyFilterChangedLength > 0" (click)="saveFilter()">
          <ion-label>Speichern <span> ({{anyFilterChangedLength}})</span></ion-label>
        </ion-chip>
      </div>
    </div>
  </section>

  <section id="loading" *ngIf="boardTemplateSrv.isLoading">
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
  </section>

  <section id="wrappers" [class.onDrag]="onDrag" *ngIf="!boardTemplateSrv.isLoading && boardTemplateSrv.templates.length > 0 ">
    <div *ngFor="let board of boardSrv.boards; let i = index" style="display: flex;">
      <div class="board-drop-line" *ngIf="i == 0 && !board.hidden" [attr.data-sectionvalue]="0"></div>
      <div *ngIf="!board.hidden">
        <div class="board-wrapper" [attr.data-sectionvalue]="i" [ngStyle]="{'background': !boardSrv.coloredBoards ? null : board.id | TicketStateColor : false : '0.05'}">
          <div class="wrapper-label" [class.headerFixed]="wrapperHeaderFixxed" [attr.data-sectionvalue]="i" [attr.data-boardid]="board.id"  [ngStyle]="{'backdrop-filter': !boardSrv.coloredBoards ? null : 'blur(15px) brightness(0.9)', 'background': boardSrv.coloredBoards ? 'none' : null}">
            <div [ngStyle]="{background: board.id | TicketStateColor : false : 0.2}">{{board.label}} <span>({{board?.ticketCount}})</span></div>
            <div class="wrapper-settings">
              <div class="hover-bttn" (click)="hideUnhideGroup(board, true)">
                <ion-icon name="fa-eye-slash"></ion-icon>
              </div>
              <div class="hover-bttn" (click)="addNewTicket(board.id)" *ngIf="!isSinglePage">
                <ion-icon name="fa-plus"></ion-icon>
              </div>
            </div>
          </div>
          <div style="height: 37px"></div>
          <div class="board-item" style="height: 3px; width: 100%;" [attr.data-sectionvalue]="0" [attr.data-sortnumber]="0" [attr.data-boardnumber]="i"></div>
          <board-item *ngFor="let item of board.tickets; let ticketIndex = index" [scrollIndicatorTriggered]="scrollIndicatorTriggered" [isSinglePage]="isSinglePage" [boardItem]="item" [boardId]="i" [statusId]="board.id" [ticketIndex]="ticketIndex" [colored]="boardSrv.coloredBoards" (dragStart)="itemDragStart($event)" (dragMove)="checkIsOverAnyDropable($event)" (dragEnd)="itemDragEnd($event)"></board-item>
          
          <div *ngIf="board.tickets.length == 0" [attr.data-sectionvalue]="0" [attr.data-boardnumber]="i" class="board-wrapper-dropable"></div>
          
          <div class="c-bttn newButton" *ngIf="board.tickets.length == 0 && !isSinglePage" (click)="addNewTicket(board.id)" [ngStyle]="{'background': !boardSrv.coloredBoards ? null : board.id | TicketStateColor : false : '0.07'}">
            <ion-icon name="fa-plus"></ion-icon>
            Neu
          </div>
          <p class="no-content" *ngIf="board.tickets.length == 0 && isSinglePage">Keine Tickets</p>
          <div class="c-bttn newButton" style="margin-top: 5px" (click)="loadOffset(board, $event)" *ngIf="board.tickets.length % 10 == 0 && board.tickets.length > 0 && !board.hasNotMoreTickets" [ngStyle]="{'background': !coloredBoards ? null : board.id | TicketStateColor : false : '0.07'}">
            <ion-icon name="fa-arrow-down"></ion-icon>
            Mehr laden...
          </div>
        </div>
      </div>
      <div class="board-drop-line" [attr.data-sectionvalue]="i + 1" *ngIf="!board.hidden"></div>


    </div>
    <div class="board-drop-line" [attr.data-sectionvalue]="boardSrv.boards.length"></div>
    <div id="hidden-groups" *ngIf="isSomeOneHidden">
      <h3>Versteckte Gruppen</h3>
      <div id="hidden-group-wrapper">
        <div class="hidden-group-item" *ngFor="let board of boardSrv.boards" [attr.data-sectionvalue]="board.id" [ngStyle]="{'display': board.hidden ? 'block' : 'none'}">
          <div *ngIf="board.hidden" [ngStyle]="{background: board.id | TicketStateColor : false : 0.05}" (click)="openHiddenGroup($event,board)">
            <div>{{board.label}} ({{board.ticketCount}})</div>
            <div style="display: flex;">
              <div class="hover-bttn" (click)="addNewTicket(board.id, $event)" *ngIf="!isSinglePage">
                <ion-icon name="fa-plus"></ion-icon>
              </div>
              <div class="hover-bttn" (click)="hideUnhideGroup(board, false)">
                <ion-icon name="fa-eye"></ion-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</ion-content>

<ion-content *ngIf="!genralSrv.serverVersionGreaterThan('1.10.0')" class="ion-padding">
  <div class="incorrect-server">
    <h1>Um das Board nutzen zu können, muss der Server mindestens die Version 1.10.0 haben.</h1>
  </div>
</ion-content>

<ion-content *ngIf="resizeManager.isPortrait" class="ion-padding">
  <div class="incorrect-server">
    <h1>Boards sind nur auf größeren Bildschirmen verfügbar.</h1>
  </div>
</ion-content>